const root = 'importList-importListProduct-descriptionTab'

export const TestId = {
  description: `${root}-description`,
}
